$(function () {
    /*$(".button-collapse").sideNav();*/
    $('[data-toggle="tooltip"]').tooltip();
    $(document).on('keyup', function (evt) {
        if (evt.keyCode == 27) {
            $('[data-toggle="tooltip"]').tooltip('hide');
        }
    });
    var sideNav = document.querySelector('.side-nav');
    if (sideNav !== null) Ps.initialize(sideNav);
    $('.luis-help').tooltip({placement:'bottom',html:true,animation:true});
    $('.luis-cph').keyup(function (e) {
        if (e.keyCode === 9 && e.shiftKey) {
            $(this).focus();
            return;
        }
        var txt = $(this).val();
        var val = '';
        for (var i = 0; i < txt.length; i++) {
            if (txt.substr(i, 1) >= '0' && txt.substr(i, 1) <= '9') {
                if (val.length === 2 || val.length === 8) val += ' / ';
                val += txt.substr(i, 1);
            }
            if (val.length === 15) {
                $('#Herd_Ref').focus();
                break;
            }
        }
        $(this).val(val);
    });
    $('.luis-cph').blur(function () {
        var cph = $(this).val().replace(/\//g,'');
        var els = cph.split('/');
        if (cph.length < 9) {
            cph = (cph + '000000000').substr(0, 9);
            $('.luis-cph').val(cph);
            $('.luis-cph').keyup();
        }
    });

    $('.luis-changeLanguage').click(function () {
        $('#selectLanguage').submit();
    });
    //to fix mdb4 error
    $('.dropdown').on('hide.bs.dropdown', function () {
        $('.dropdown-toggle', this).attr('aria-expanded', false);
    });
});
// Expose utility functions globally for use in inline scripts
window.formToDict = function() {
    var arr = $('form').serializeArray();
    var rtn = {};
    for (var i = 0; i < arr.length; i++) {
        rtn[arr[i].name] = arr[i].value;
    }
    return rtn;
};
window.htmlEncode = function(el) {
    let div = document.createElement('div');
    div.textContent = el;
    return div.innerHTML;
};
window.repIcon = function(divisor, replica) {
    if (replica === 0 || divisor === 0 || ((replica - 1) % divisor + 1) === replica) return '';

    const series = parseInt((replica - 1) / divisor);
    const badge = ' <span class="luis-hidden-text"> Replica printed counter is </span ><span class="luis-replica badge badge-light border' + (series > 0 ? ' badge-pill' : '') + '">' + (((replica - 1) % divisor) + 1) + '</span>';
    return badge;
};

// Toast notification function using Bootstrap 5's native toast component
// Replaces toastr library functionality
// Exposed on window for inline page scripts (Razor Sections, etc.)
// Parameters:
//   message (required): The message to display
//   type (optional, default: 'info'): One of 'info', 'error', 'success', 'warning'
//   options (optional): Additional options (for future extensibility)
window.showToast = function showToast(message, type, options) {
    // Default to 'info' if type is not provided or invalid
    type = type || 'info';
    var validTypes = ['info', 'error', 'success', 'warning'];
    if (validTypes.indexOf(type) === -1) {
        type = 'info';
    }

    // text-bg-* pairs background + WCAG-friendly foreground (avoids white on light cyan etc.)
    var typeClasses = {
        'info': 'text-bg-info',
        'error': 'text-bg-danger',
        'success': 'text-bg-success',
        'warning': 'text-bg-warning'
    };

    // Light toast themes use default btn-close; dark (danger/success) need white variant
    var closeButtonClassByType = {
        'info': 'btn-close',
        'error': 'btn-close btn-close-white',
        'success': 'btn-close btn-close-white',
        'warning': 'btn-close'
    };

    // Use a dedicated id — #toast-container is styled by toastr.css (opacity 0.8, white text) and breaks Bootstrap toasts
    var toastContainer = $('#luis-bs-toast-container');
    if (toastContainer.length === 0) {
        toastContainer = $('<div id="luis-bs-toast-container" class="toast-container position-fixed end-0 p-3" style="top: 4.75rem; z-index: 1090;"></div>');
        $('body').append(toastContainer);
    }

    // Create unique ID for this toast
    var toastId = 'toast-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);

    var toast = $('<div class="toast align-items-center border-0 shadow" role="alert" aria-live="assertive" aria-atomic="true" id="' + toastId + '"></div>');
    toast.addClass(typeClasses[type]);

    var toastBody = $('<div class="d-flex align-items-center"></div>');
    var toastMessage = $('<div class="toast-body flex-grow-1 py-2 pe-2 fw-semibold"></div>').text(message);
    var closeButton = $('<button type="button" class="' + closeButtonClassByType[type] + ' flex-shrink-0 ms-1" data-bs-dismiss="toast" aria-label="Close"></button>');

    toastBody.append(toastMessage);
    toastBody.append(closeButton);
    toast.append(toastBody);
    
    // Append to container
    toastContainer.append(toast);
    
    // Initialize and show using Bootstrap 5's Toast API
    var bsToast = new bootstrap.Toast(toast[0], {
        autohide: true,
        delay: 4000
    });
    
    // Remove element after it's hidden
    toast[0].addEventListener('hidden.bs.toast', function () {
        $(this).remove();
    });
    
    bsToast.show();
}


$(document).on('change', '.file-field input[type="file"]', function (e) {
    var $this = $(e.target);
    var $fileField = $this.closest('.file-field');
    var $pathInput = $fileField.find('input.file-path');
    var files = $this[0].files;
    var fileNames = [];

    if (files && files.length > 0) {
        for (var i = 0; i < files.length; i++) {
            fileNames.push(files[i].name);
        }
        $pathInput.val(fileNames.join(', '));
        $pathInput.trigger('change');
    }
});